import { TYPOGRAPHY_COLORS } from 'constants/TypographyColors'
import { SVGIcon } from './SvgIcon/SvgIcon'
import { IconProps } from './types'

export const ArrowChangeIcon = ({
  size,
  color = 'grey400',
  className,
  rotate,
  dataTestId,
}: IconProps) => (
  <SVGIcon
    size={size}
    rotate={rotate}
    viewBox="0 0 16 16"
    color={color}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      d="M13.328 8.02136C13.3227 9.37936 12.8073 10.7354 11.7713 11.7714C9.68866 13.854 6.31133 13.854 4.22866 11.7714C3.85799 11.4007 3.55666 10.988 3.31799 10.5507"
      stroke={TYPOGRAPHY_COLORS[color]}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M2.66931 7.91329C2.69064 6.57729 3.20931 5.24796 4.22864 4.22863C6.31131 2.14596 9.68864 2.14596 11.7713 4.22863C12.142 4.59929 12.4433 5.01196 12.682 5.44929"
      stroke={TYPOGRAPHY_COLORS[color]}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M10.6354 5.44998H12.992V3.09265"
      stroke={TYPOGRAPHY_COLORS[color]}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M5.36472 10.5499H3.00806V12.9073"
      stroke={TYPOGRAPHY_COLORS[color]}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SVGIcon>
)
